/*
 Copyright 2019-present wobe-systems GmbH

 Licensed under the Apache License, Version 2.0 (the 'License');
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an 'AS IS' BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
import { GetterTree } from 'vuex';
import * as types from '@/store/types';
import { Constant, SchemaType } from '@/scripts/shareModels/schema';
import { FlowsState, Flow } from './models';
import { RootState } from '../models';

export const getters: GetterTree<FlowsState, RootState> = {
  [types.GET_LOADING]({ loading }): FlowsState['loading'] {
    return loading;
  },

  [types.GET_FLOW_NAME](state): FlowsState['flow']['name'] {
    const { name } = state.flow;
    const flowName = name || '';
    return `${flowName}`;
  },

  [types.GET_RUN_STATE](state): FlowsState['flow']['running'] {
    const { running } = state.flow;
    const flowRunState = running || false;
    return flowRunState;
  },

  [types.GET_FLOWS](state): FlowsState['flows'] {
    return state.flows;
  },

  [types.GET_PORT](state): FlowsState['port'] {
    return state.port;
  },

  [types.GET_BRICKS](state): FlowsState['flow']['config']['bricks'] {
    const { bricks } = (state.flow || ({} as FlowsState['flow'])).config;
    return bricks;
  },

  [types.GET_CONNECTIONS](state): FlowsState['connections'] {
    return state.connections || [];
  },

  [types.GET_FLOW_NAMES](state): FlowsState['flows'] {
    const { selectedFlows } = state;
    return selectedFlows;
  },

  [types.GET_ALL_BRICKS](state): FlowsState['bricks'] {
    const allbricks: FlowsState['bricks'] = state.bricks;
    return allbricks;
  },

  [types.GET_FLOW](state): Flow {
    return state.flow;
  },

  [types.GET_IS_DIRTY](state): Flow['isDirty'] {
    return state.flow.isDirty;
  },

  [types.GET_SORT_FLOWS_BY](state): FlowsState['sortFlowsBy'] {
    return state.sortFlowsBy;
  },

  [types.GET_CONSTANTS](state): Constant[] {
    return state.flow.config
      && state.flow.config.constants
      ? state.flow.config.constants : [];
  },

  [types.GET_SOURCE_TO_BUFFER](state): FlowsState['connectionSource'] {
    return state.connectionSource;
  },

  [types.GET_UPDATE_BRICK_LOADING](state): FlowsState['updateBrickLoading'] {
    return state.updateBrickLoading;
  },
};
